import { Check } from "lucide-react";
import FormShell from "../components/FormShell";
import { placeImg } from "../utils/constants";

const VIBES_PHOTO = [
  { value: "Street food & ramen", hint: "Steam, sizzle, standing counters", image: "/places/menbaka-fire-ramen.jpg" },
  { value: "Temples & zen", hint: "Stone paths, moss gardens, silence", image: "/places/genko-an.jpg" },
  { value: "Neon & city energy", hint: "Shibuya glow, midnight pulse", image: "/places/dotonbori.jpg" },
  { value: "Hidden backstreets", hint: "Alleys only locals know", image: "/places/pontocho-alley.jpg" },
  { value: "Photography", hint: "Golden light, quiet frames", image: "/places/fushimi-inari-taisha.jpg" },
  { value: "Shopping & fashion", hint: "Vintage finds, Harajuku layers", image: "/places/takeshita-street.jpg" },
  { value: "Nature & parks", hint: "Bamboo, cherry blossoms, coastline", image: "/places/keage-incline.jpg" },
  { value: "Nightlife & bars", hint: "Tiny doors, tall drinks, late nights", image: "/places/star-bar-ginza.jpg" },
  { value: "Art & museums", hint: "Teamlab to ukiyo-e", image: "/places/art-aquarium-ginza.jpg" },
  { value: "Family fun", hint: "Pokemon, parks, zero stress", image: "/places/aquarium-kaiyukan.jpg" },
];

function PhotoCard({ vibe, selected, onToggle }) {
  return (
    <button
      onClick={onToggle}
      style={{
        position: "relative",
        display: "block",
        width: "100%",
        height: 130,
        borderRadius: 4,
        overflow: "hidden",
        textAlign: "left",
        cursor: "pointer",
        padding: 0,
        border: "none",
        boxShadow: selected
          ? "0 0 0 2.5px var(--zen-accent), 0 8px 24px rgba(0,0,0,0.2)"
          : "0 2px 8px rgba(0,0,0,0.1)",
        transition: "box-shadow 0.3s ease",
      }}>

      {/* Photo */}
      <div style={{
        position: "absolute", inset: 0,
        backgroundImage: `url(${placeImg(vibe.image)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        transform: selected ? "scale(1.05)" : "scale(1)",
        transition: "transform 0.5s ease",
      }} />

      {/* Dark gradient */}
      <div style={{
        position: "absolute", inset: 0,
        background: "linear-gradient(to top, rgba(0,0,0,0.74) 0%, rgba(0,0,0,0.25) 45%, rgba(0,0,0,0.08) 100%)",
      }} />

      {/* Red tint on select */}
      {selected && (
        <div style={{ position: "absolute", inset: 0, background: "rgba(232,37,41,0.12)" }} />
      )}

      {/* Checkmark */}
      <div style={{
        position: "absolute", top: 10, left: 10,
        width: 24, height: 24, borderRadius: "50%",
        display: "flex", alignItems: "center", justifyContent: "center",
        background: selected ? "var(--zen-accent)" : "rgba(0,0,0,0.3)",
        border: selected ? "none" : "2px solid rgba(255,255,255,0.4)",
        boxShadow: selected ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
        transition: "all 0.2s ease",
      }}>
        {selected && <Check size={14} color="#fff" strokeWidth={3} />}
      </div>

      {/* Text */}
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: 14 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#fff", lineHeight: 1.3, textShadow: "0 1px 4px rgba(0,0,0,0.5)" }}>
          {vibe.value}
        </div>
        <div style={{ fontSize: 11, marginTop: 2, lineHeight: 1.3, color: "rgba(255,255,255,0.75)", textShadow: "0 1px 3px rgba(0,0,0,0.4)" }}>
          {vibe.hint}
        </div>
      </div>
    </button>
  );
}

export default function VibesPage({
  onNext, onBack, startOver,
  selectedVibes, setSelectedVibes,
}) {
  const toggle = (vibe) => {
    setSelectedVibes(prev =>
      prev.includes(vibe) ? prev.filter(v => v !== vibe) : [...prev, vibe]
    );
  };

  return (
    <FormShell
      step={5}
      photo="/photos/onboard-vibes"
      photoPos="46% 43%"
      eyebrow="WHAT'S YOUR VIBE?"
      bigWord="VIBE?"
      title="What excites you about Japan?"
      subtitle="Tap everything that speaks to you"
      onBack={onBack}
      onStartOver={startOver}
      onContinue={onNext}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {VIBES_PHOTO.map((vibe) => (
          <PhotoCard key={vibe.value} vibe={vibe} selected={selectedVibes.includes(vibe.value)}
            onToggle={() => toggle(vibe.value)} />
        ))}
      </div>

      {selectedVibes.length > 0 && (
        <div style={{ textAlign: "center", fontSize: 14, color: "var(--zen-accent)", fontWeight: 500 }}>
          {selectedVibes.length} {selectedVibes.length === 1 ? "vibe" : "vibes"} selected
        </div>
      )}
    </FormShell>
  );
}
